import { render, staticRenderFns } from "./relevance-form-modal.vue?vue&type=template&id=cfee7a9c&scoped=true&"
import script from "./relevance-form-modal.vue?vue&type=script&lang=ts&"
export * from "./relevance-form-modal.vue?vue&type=script&lang=ts&"
import style0 from "./relevance-form-modal.vue?vue&type=style&index=0&id=cfee7a9c&lang=less&scoped=true&"
import style1 from "./relevance-form-modal.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfee7a9c",
  null
  
)

export default component.exports